import React from "react";
import {Auth} from "aws-amplify";
import JointCognitoUser from "../types/jointCognitoUser";
import {useLocalStorage} from "./useLocalStorage";
import {authConstants} from "../constants/auth.constants";

export default function useCurrentUser() {
  const [user, setUser] = React.useState<JointCognitoUser | null>(null);
  const [externalUser, setExternalUser] = useLocalStorage(authConstants.LOCAL_STORAGE_KEY, null);
  React.useEffect(() => {
    const getUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        setUser(user as JointCognitoUser);
        const {signInUserSession} = user;
        setExternalUser(signInUserSession.accessToken.jwtToken);
      } catch(e) {
        if(externalUser) {
          setExternalUser(null);
        }
      }
    }
    getUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return user;
}
